import React, {useEffect, useState} from 'react';

// custom components
import { Text } from '../../../atoms'

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';

// icons
import { BsArrowRight, BsArrowLeft } from 'react-icons/bs';

// colors
import { Colors } from '../../../../styles/index';

const PageNavigator = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    const ClickText = (props) => {
        return (
            <Nav.Link href={props.link} style={{
                display:'flex',
            }}>
                {
                    props.arrow == 'left' ?
                        <BsArrowLeft size={20} color={Colors.GRAY_DARK} style={{cursor:'pointer', paddingRight:2}} onClick={()=>{console.log('arrow pressed')}} />
                    :
                    null
                }
                <p
                    style={{
                        marginTop:-2,
                        color:Colors.GRAY_DARK,
                        cursor:'pointer'           
                    }}
                >{props.text}</p>
                {
                    props.arrow == 'right' ?
                        <BsArrowRight size={20} color={Colors.GRAY_DARK} style={{cursor:'pointer', paddingLeft:2}} onClick={()=>{console.log('arrow pressed')}} />
                    :
                    null
                }
            </Nav.Link>
        )
    }

    return (
            <Container className='mt-5' style={{display:'flex', justifyContent:'space-between'}}>
                { props.left == false ? '' :
                <ClickText 
                    text={props.leftText}
                    arrow={'left'}
                    link={props.leftLink}
                />
                }
                { props.right == false ? '' :
                <ClickText 
                    text={props.rightText}
                    arrow={'right'}
                    link={props.rightLink}
                />
                }
            </Container>
    );
};

export default PageNavigator;